import { useEffect, useState } from "react";
import {
  Wifi,
  WifiOff,
} from "lucide-react";

export function OfflineBanner() {
  const [online, setOnline] = useState(
    navigator.onLine,
  );

  const [showRestored, setShowRestored] =
    useState(false);

  useEffect(() => {
    function handleOffline() {
      setOnline(false);
      setShowRestored(false);
    }

    function handleOnline() {
      setOnline(true);
      setShowRestored(true);

      window.setTimeout(() => {
        setShowRestored(false);
      }, 3000);
    }

    window.addEventListener(
      "offline",
      handleOffline,
    );

    window.addEventListener(
      "online",
      handleOnline,
    );

    return () => {
      window.removeEventListener(
        "offline",
        handleOffline,
      );

      window.removeEventListener(
        "online",
        handleOnline,
      );
    };
  }, []);

  if (!online) {
    return (
      <div className="bg-amber-600 px-4 py-2 text-sm text-white">
        <div className="mx-auto flex max-w-screen-2xl items-center gap-2">
          <WifiOff className="h-4 w-4" />

          <span>
            You're offline. Some MinistryIQ
            features are unavailable until your
            connection returns.
          </span>
        </div>
      </div>
    );
  }

  if (showRestored) {
    return (
      <div className="bg-emerald-600 px-4 py-2 text-sm text-white">
        <div className="mx-auto flex max-w-screen-2xl items-center gap-2">
          <Wifi className="h-4 w-4" />

          <span>
            Connection restored.
            Refreshing data...
          </span>
        </div>
      </div>
    );
  }

  return null;
}
